import React, { useEffect, useRef } from 'react'

export const AlwaysScrollToBottom: React.FC<{ dependencies: any[] }> = ({ dependencies = [] }) => {
  const elementRef = useRef<HTMLDivElement>(null)
  useEffect(() => {
    const element = elementRef.current
    const parent = element?.parentElement
    if (parent) {
      parent.scrollTop = parent.scrollHeight
    }
  }, [...dependencies])

  return <div ref={elementRef} />
}
